// NOTE: The (old) theme palettes are based off of David's design in assets/
import * as blackbird from "./blackbird";
import * as factbird from "./factbird";
var host = typeof document !== "undefined" ? document.location.host : null;
var isFactbird = (host === null || host === void 0 ? void 0 : host.includes("factbird.com")) || (host === null || host === void 0 ? void 0 : host.includes("localhost")) || false;
var brand = isFactbird ? "factbird" : "blackbird";
export { brand, blackbird, factbird };
